import React from "react";
import { Navigation, Frame } from "@shopify/polaris";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import {LegacyCard, Tabs} from '@shopify/polaris';
import {useState, useCallback} from 'react';

import { tabsFromSections } from "../../utilities/mobile";
import { useEffect } from "react";

export default function TabContainer({ sections, children, useLastPath }) {
  const location = useLocation();
  const path = useLastPath
    ? location.pathname.split("/").at(-1)
    : location.pathname;

  const navigate = useNavigate();

  const tabs = tabsFromSections(sections);
  const [selected, setSelected] = useState(() => tabMatcher());

  function tabMatcher(){
    var index = -1;
    if(tabs){
      tabs.forEach((tab, i) => {
        if (path == tab.path) {
          index = i;
        }
      });
    }
    //fallback to handle edit path with id
    if(tabs && index == -1){
      tabs.forEach((tab, i) => {
        if (path.includes(tab.path)) {
          index = i;
        }
      });
    }
    //tabcontainer not matching
    if(index == -1){
      index = 0;
     // console.log("TabContainer not matching path: " + path);
    }
    return index;
  }

  const tabChanged = useCallback((selectedTabIndex) => {
    setSelected(selectedTabIndex);
    navigate(tabs[selectedTabIndex].path);
  }, []);

  useEffect(() => {
    // execute on location change
    setSelected(tabMatcher());
  }, [location]);

  return (
    <Frame
      navigation={
        <Navigation location={path}>
          {sections && sections.map((section, index) => {
            return <Navigation.Section {...section} key={index} />;
          })}
        </Navigation>
      }
    >
      <div className="mobile-tabs">
        <LegacyCard>
          <Tabs tabs={tabs} selected={selected} onSelect={tabChanged}/>
        </LegacyCard>
      </div>
      {children}
      <Outlet />
    </Frame>
  );
}
